import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import AssetTypesTable from "@/components/ListTable/AssetTypesTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import AssetTypeAddButton from "@/modules/asset-type/asset-type-add-button";
import { ListProvider } from "@/modules/list";

const AssetTypes = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("global:assetTypePlural")}
        extra={[<AssetTypeAddButton key="asset-type-add-button" />]}
      />
      <AppLayoutPage>
        <ListProvider
          endpoint="assetTypes"
          storageKey={STORAGE_KEYS.ASSET_TYPE_TEMPLATES}
        >
          <AssetTypesTable />
        </ListProvider>
      </AppLayoutPage>
    </>
  );
};

export default AssetTypes;
